"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.x_small = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const x_small = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'x-small-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4.46967 4.65998C4.76256 4.36708 5.23744 4.36708 5.53033 4.65998L10 9.12965L14.4697 4.65998C14.7626 4.36708 15.2374 4.36708 15.5303 4.65998C15.8232 4.95287 15.8232 5.42774 15.5303 5.72064L11.0607 10.1903L15.5303 14.66C15.8232 14.9529 15.8232 15.4277 15.5303 15.7206C15.2374 16.0135 14.7626 16.0135 14.4697 15.7206L10 11.251L5.53033 15.7206C5.23744 16.0135 4.76256 16.0135 4.46967 15.7206C4.17678 15.4277 4.17678 14.9529 4.46967 14.66L8.93934 10.1903L4.46967 5.72064C4.17678 5.42774 4.17678 4.95287 4.46967 4.65998Z', fill: '#4B5563' })));
};
exports.x_small = x_small;
